import { Control } from "react-hook-form";
import { FormEventHandler } from "react";
import { Buttons } from "../../../atoms/Buttons";
import { InputText } from "../../../atoms/Inputs/InputText";
import * as S from "../Modals.style";
import { ControlTel } from "../../../atoms/controls/ControlTel";
import { ControlText } from "../../../atoms/controls/ControlText";
import { ControlSelect } from "../../../atoms/controls/ControlSelect";
import { SelectOption } from "../../../../common/types/selectOption";
import { ModalProps, Modals } from "..";

interface UserCreateModalProps extends ModalProps {
  control: Control<any>;
  permissionSelectOptions: SelectOption[];
  onSubmit: FormEventHandler;
  userGroup?: string;
  onResetPassword?: () => void;
}

export const ModalUser = ({
  onSubmit,
  userGroup,
  modalType,
  formId,
  setModalShow,
  permissionSelectOptions,
  control,
  onResetPassword,
}: UserCreateModalProps) => {
  return (
    <Modals
      modalTitle={
        userGroup === "Master" ? (
          "Master 정보 보기"
        ) : modalType === "modify" ? (
          <>
            사용자 정보 수정
            <Buttons
              type="button"
              size="md"
              layout="primary"
              label="비밀번호 초기화"
              onClick={onResetPassword}
            />
          </>
        ) : (
          "사용자 등록"
        )
      }
      formId={formId}
      setModalShow={setModalShow}
      modalButtons={
        <>
          <Buttons
            type="submit"
            size="md"
            layout="primary"
            label="저장"
            form={formId}
            onClick={onSubmit}
          />
          <Buttons
            type="button"
            size="md"
            layout="secondary"
            label="취소"
            onClick={() => setModalShow(false)}
          />
        </>
      }
    >
      <form>
        <S.ModalContentForm>
          <ControlText
            name={"mbrUserId"}
            control={control}
            direction="column"
            size="md"
            width={400}
            label="사용자 ID"
            placeholder="ID를 입력하세요."
            disabled={modalType === "modify" ? true : false}
          />
          {modalType === "create" && (
            <ControlText
              name={"mbrUserPwd"}
              control={control}
              type="password"
              direction="column"
              size="md"
              width={400}
              label="비밀번호"
              placeholder="비밀번호를 입력하세요."
            />
          )}
          <ControlText
            name={"mbrUserDepartment"}
            control={control}
            direction="column"
            size="md"
            width={400}
            label="소속"
            placeholder="소속을 입력하세요."
          />
          <ControlText
            name={"mbrUserRank"}
            control={control}
            direction="column"
            size="md"
            width={400}
            label="계급"
            placeholder="계급을 입력하세요."
          />
          <ControlText
            name={"mbrUserName"}
            control={control}
            direction="column"
            size="md"
            width={400}
            label="성명"
            placeholder="성명을 입력하세요."
          />
          <ControlTel
            name={"mbrUserTell"}
            control={control}
            direction="column"
            size="md"
            width={400}
            label="연락처"
            placeholder="연락처를 입력하세요."
            maxLength={13}
          />
          {userGroup === "Master" ? (
            <ControlText
              name={"mbrUserGroup"}
              control={control}
              direction="column"
              size="md"
              width={400}
              label="권한"
              disabled={true}
              value="Master"
            />
          ) : (
            <ControlSelect
              name={"mbrUserGroup"}
              control={control}
              direction="column"
              size="md"
              width={400}
              label="권한"
              options={permissionSelectOptions}
              placeholder="그룹 선택"
            />
          )}
        </S.ModalContentForm>
      </form>
    </Modals>
  );
};

// import { ModalProps, Modals } from "..";
// import { Buttons } from "../../../atoms/Buttons";
// import { InputSelect } from "../../../atoms/Inputs/InputSelect";
// import { InputText } from "../../../atoms/Inputs/InputText";

// export const ModalUser = (props: ModalProps) => {
//   return (
//     <Modals
//       modalTitle={
//         props.userAuth === "modify" ? (
//           <>
//             사용자 정보 수정
//             <Buttons
//               type="button"
//               size="md"
//               layout="primary"
//               label="비밀번호 초기화"
//             />
//           </>
//         ) : props.userAuth === "master" ? (
//           "Master 정보 보기"
//         ) : (
//           "사용자 등록"
//         )
//       }
//       formId={props.formId}
//       setModalShow={props.setModalShow}
//       modalButtons={
//         <>
//           <Buttons
//             type="submit"
//             size="md"
//             layout="primary"
//             label="저장"
//             form={props.formId}
//           />
//           <Buttons
//             type="button"
//             size="md"
//             layout="secondary"
//             label="취소"
//             onClick={() => props.setModalShow(false)}
//           />
//         </>
//       }
//     >
//       <>
//         <InputText
//           direction="column"
//           size="md"
//           width={400}
//           label="사용자 ID"
//           placeholder="ID를 입력하세요."
//           disabled={props.userAuth === "modify" ? true : false}
//         />
//         <InputText
//           direction="column"
//           size="md"
//           width={400}
//           label="소속"
//           placeholder="소속을 입력하세요."
//         />
//         <InputText
//           direction="column"
//           size="md"
//           width={400}
//           label="계급"
//           placeholder="계급을 입력하세요."
//         />
//         <InputText
//           direction="column"
//           size="md"
//           width={400}
//           label="성명"
//           placeholder="성명을 입력하세요."
//         />
//         {props.userAuth === "master" ? (
//           <InputText
//             direction="column"
//             size="md"
//             width={400}
//             label="권한"
//             disabled={true}
//           />
//         ) : (
//           <InputSelect
//             direction="column"
//             size="md"
//             width={400}
//             label="권한"
//             placeholder="그룹 선택"
//           />
//         )}
//       </>
//     </Modals>
//   );
// };
